import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { IoMdAdd, IoMdSearch } from 'react-icons/io'

const Navbar = ({ searchTerm, setSearchTerm, user }) => {
  const navigate = useNavigate()

  if (!user) return null

  return (
    <div className="flex gap-2 md:gap-5 w-full mt-5 pb-7">
      <div className="flex justify-start items-center w-full px-2 rounded-md bg-white border-none outline-none focus-within:shadow-sm">
        <IoMdSearch fontSize={21} className="ml-1" />
        <input
          type="text"
          onChange={event => {setSearchTerm(event.target.value)}}
          placeholder="Поиск"
          value={searchTerm}
          onInput={() => navigate('/search')}
          className="p-2 w-full bg-white outline-none"
        />
      </div>
      <div className="flex gap-3">
        <Link to={`user-profile/${user?._id}`} className="hidden md:block">
          <img src={user.image} alt="User" className="w-12 h-12 rounded-full"/>
        </Link>
        {window.location.pathname !== '/create-pin' && (
          <Link
            to="create-pin"
            className="fixed bottom-5 right-1/2 translate-x-1/2 md:translate-x-0 md:right-10 z-10 flex items-center font-bold bg-white rounded-full pl-4 shadow-md"
          >
            Создать Пин
            <div
              className="ml-3 bg-red-500 text-white rounded-full w-14 h-14 md:w-12 md:h-12 flex justify-center items-center text-3xl"
            >
              <IoMdAdd />
            </div>
          </Link>
          )}
      </div>
    </div>
  )
}

export default Navbar